"use client";

import { useEffect } from "react";
import { useRouter, usePathname } from "next/navigation";
import { useAuth } from "@/lib/auth-context";

export function RequireAuth({
  children,
}: {
  children: React.ReactNode;
  /** Kept for call-site compatibility; set selection is sidebar-only. */
  requireDocumentSet?: boolean;
}) {
  const { user, loading } = useAuth();
  const router = useRouter();
  const pathname = usePathname();

  useEffect(() => {
    if (loading) return;
    if (!user) {
      router.replace("/");
      return;
    }
    if (user.mustChangePassword && pathname !== "/change-password") {
      router.replace("/change-password");
    }
  }, [loading, user, router, pathname]);

  if (loading || !user) {
    return (
      <div className="flex items-center justify-center min-h-[calc(100vh-100px)]">
        <p className="text-muted">Loading...</p>
      </div>
    );
  }

  if (user.mustChangePassword && pathname !== "/change-password") {
    return (
      <div className="flex items-center justify-center min-h-[calc(100vh-100px)]">
        <p className="text-muted">Password change required...</p>
      </div>
    );
  }

  return <>{children}</>;
}
